import React, { useEffect } from 'react'
import { Button, Result } from 'antd'
import { Route, BrowserRouter as Router, Switch, useLocation } from 'react-router-dom'
import allPaths from './paths'
import { Home, Service, Clinic, Sterilization, Egypt, Contact, Blog, OurTeam, DentalService, AestheticsDentistry, EndodonticDentistry, OralSurgery, OrthodonticDentistry, ProsthodonticDentistry, PeriodontalDentistry, DentalImplants, PedodonticDentistry, ContentForm, ServiceForm, DoctorForm, DoctorRoomForm, Login, DoctorLogin, ClanicProfile, ContactData} from '../Screens'
import { Layout } from '../Components'
import { SecondLayout } from '../SecondComponents'
import { ThirdLayout } from '../ThirdComponents'
import { SecondHome, SecondService, Procedure, SecondAbout, BeforeAfter, Portfolio, Appointment, About, DentalStore, Shop, ProcedureDentistry, DentalFilling, DentalBridges, Veneers, Invisalign, Crowns, PortfolioCard1, PortfolioCard2, PortfolioCard3, PortfolioCard4, PortfolioCard5, PortfolioCard6, PortfolioCard7, PortfolioCard8, PortfolioCard9, PortfolioCard10, PortfolioCard11, PortfolioCard12, SecondDesignContentForm, } from '../SecondScreens'
import { ThirdAbout, ThirdAppointment, ThirdContact, ThirdDesignContentForm, ThirdFaq, ThirdHome, ThirdService, ThirdTeam } from '../ThirdScreens'
import { FourthLayout } from '../FourthComponents'
import { FourthAbout, FourthContact, FourthDesignContentForm, FourthDoctors, FourthHome, FourthService } from '../FourthScreens'
import { FifthLayout } from '../FifthComponents'
import { FifthHome, FifthAbout, FifthSpecialities, FifthExperties, FifthLatestNews, FifthContact, FifthAppointment, WhoWeAre, MissionAndVision, CoreValues, Testimonials, Careers, FifthTeam, PhysiotherapyAndOrthopedic, Rehabilitation, NeurologyCentre, PediatricRehabilitation, BackCentreExpertise, FootLab, NeurologyCentreOfExpertise, KneeCentreOfExpertise, FifthDesignContentForm } from '../FifthScreens'
import { DoctorCalander, DoctorProfile } from '../Screens/Doctor'

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

const Page404 = (props) => {
    const { history } = props
    return (
        <Result
            status='404'
            title='404'
            subTitle='Sorry, the page you visited does not exist.'
            extra={<Button
                type='primary'
                className='form-button'
                onClick={() => history.push('/')}
            >Back Home</Button>}
        />
    )
}

const Routes = () => {
    return (
        <Router>
            <ScrollToTop />
            <Switch>
                <Layout path={allPaths?.HOME} exact component={Home} />
                <Layout path={allPaths?.SERVICE} exact component={Service} />
                <Layout path={allPaths?.CLINIC} exact component={Clinic} />
                <Layout path={allPaths?.STERILIZATION} exact component={Sterilization} />
                <Layout path={allPaths?.OURTEAM} exact component={OurTeam} />
                <Layout path={allPaths?.EGYPT} exact component={Egypt} />
                <Layout path={allPaths?.CONTACT} exact component={Contact} />
                <Layout path={allPaths?.BLOG} exact component={Blog} />
                <Layout path={allPaths?.DENTALSERVICE} exact component={DentalService} />
                <Layout path={allPaths?.AESTHETICSDENTISTRY} exact component={AestheticsDentistry} />
                <Layout path={allPaths?.ENDODONTICDENTISTRY} exact component={EndodonticDentistry} />
                <Layout path={allPaths?.ORALSURGERY} exact component={OralSurgery} />
                <Layout path={allPaths?.ORTHODONTICDENTISTRY} exact component={OrthodonticDentistry} />
                <Layout path={allPaths?.PROSTHODONTICDENTISTRY} exact component={ProsthodonticDentistry} />
                <Layout path={allPaths?.PERIODONTALDENTISTRY} exact component={PeriodontalDentistry} />
                <Layout path={allPaths?.DENTALIMPLANTS} exact component={DentalImplants} />
                <Layout path={allPaths?.PEDODONTICDENTISTRY} exact component={PedodonticDentistry} />
                <Layout path={allPaths?.SERVICEFORM} exact component={ServiceForm} />
                <Layout path={allPaths?.DOCTORFORM} exact component={DoctorForm} />
                <Layout path={allPaths?.DOCTOR_ROOM} exact component={DoctorRoomForm} />
                <Layout path={allPaths?.CLANIC_PROFILE} exact component={ClanicProfile} />
                {/* Clanic 1 doctor */}
                <Layout path={allPaths?.DOCTOR_PROFILE} exact component={DoctorProfile} />
                <Layout path={allPaths?.DOCTOR_CALANDER} exact component={DoctorCalander} />
                {/* Clanic 1 doctor */}
                <Layout path={allPaths?.CONTACT_DATA} exact component={ContactData} />
                <Route path={allPaths?.CONTENTFORM} exact component={ContentForm} />
                <Route path={allPaths?.LOGIN} exact component={Login} />
                <Route path={allPaths?.DOCTOR_LOGIN} exact component={DoctorLogin} />
                <SecondLayout path={allPaths?.SECONDHOME} exact component={SecondHome} />
                <SecondLayout path={allPaths?.SECONDSERVICE} exact component={SecondService} />
                <SecondLayout path={allPaths?.PROCEDURE} exact component={Procedure} />
                <SecondLayout path={allPaths?.PROCEDUREDENTISTRY} exact component={ProcedureDentistry} />
                <SecondLayout path={allPaths?.PROCEDUREDENTALFILLING} exact component={DentalFilling} />
                <SecondLayout path={allPaths?.PROCEDUREDENTALBRIDGES} exact component={DentalBridges} />
                <SecondLayout path={allPaths?.PROCEDUREVENEERS} exact component={Veneers} />
                <SecondLayout path={allPaths?.PROCEDUREINVISALIGN} exact component={Invisalign} />
                <SecondLayout path={allPaths?.PROCEDURECROWNS} exact component={Crowns} />
                <SecondLayout path={allPaths?.SECONDABOUT} exact component={SecondAbout} />
                <SecondLayout path={allPaths?.ABOUT} exact component={About} />
                <SecondLayout path={allPaths?.DENTALSTORE} exact component={DentalStore} />
                <SecondLayout path={allPaths?.SHOP} exact component={Shop} />
                <SecondLayout path={allPaths?.BEFOREAFTER} exact component={BeforeAfter} />
                <SecondLayout path={allPaths?.PORTFOLIO} exact component={Portfolio} />
                <SecondLayout path={allPaths?.PORTFOLIOCARD1} exact component={PortfolioCard1} />
                <SecondLayout path={allPaths?.PORTFOLIOCARD2} exact component={PortfolioCard2} />
                <SecondLayout path={allPaths?.PORTFOLIOCARD3} exact component={PortfolioCard3} />
                <SecondLayout path={allPaths?.PORTFOLIOCARD4} exact component={PortfolioCard4} />
                <SecondLayout path={allPaths?.PORTFOLIOCARD5} exact component={PortfolioCard5} />
                <SecondLayout path={allPaths?.PORTFOLIOCARD6} exact component={PortfolioCard6} />
                <SecondLayout path={allPaths?.PORTFOLIOCARD7} exact component={PortfolioCard7} />
                <SecondLayout path={allPaths?.PORTFOLIOCARD8} exact component={PortfolioCard8} />
                <SecondLayout path={allPaths?.PORTFOLIOCARD9} exact component={PortfolioCard9} />
                <SecondLayout path={allPaths?.PORTFOLIOCARD10} exact component={PortfolioCard10} />
                <SecondLayout path={allPaths?.PORTFOLIOCARD11} exact component={PortfolioCard11} />
                <SecondLayout path={allPaths?.PORTFOLIOCARD12} exact component={PortfolioCard12} />
                <SecondLayout path={allPaths?.APPOINTMENT} exact component={Appointment} />
                <SecondLayout path={allPaths?.SECONDDESIGNSERVICEFORM} exact component={ServiceForm} />
                <SecondLayout path={allPaths?.SECONDDESIGNDOCTORFORM} exact component={DoctorForm} />
                <Route path={allPaths?.SECONDDESIGNCONTENTFORM} exact component={SecondDesignContentForm} />
                <ThirdLayout path={allPaths?.THIRDHOME} exact component={ThirdHome} />
                <ThirdLayout path={allPaths?.THIRDABOUT} exact component={ThirdAbout} />
                <ThirdLayout path={allPaths?.THIRDSERVICE} exact component={ThirdService} />
                <ThirdLayout path={allPaths?.THIRDAPPOINTMENT} exact component={ThirdAppointment} />
                <ThirdLayout path={allPaths?.THIRDOURTEAM} exact component={ThirdTeam} />
                <ThirdLayout path={allPaths?.THIRDOURFAQS} exact component={ThirdFaq} />
                <ThirdLayout path={allPaths?.THIRDOURCONTACT} exact component={ThirdContact} />
                <Route path={allPaths?.THIRDDESIGNCONTENTFORM} exact component={ThirdDesignContentForm} />
                <FourthLayout path={allPaths?.FOURHTHOME} exact component={FourthHome} />
                <FourthLayout path={allPaths?.FOURHTABOUT} exact component={FourthAbout} />
                <FourthLayout path={allPaths?.FOURHTSERVICE} exact component={FourthService} />
                <FourthLayout path={allPaths?.FOURHTDOCTORS} exact component={FourthDoctors} />
                <FourthLayout path={allPaths?.FOURHTCONTACT} exact component={FourthContact} />
                <Route path={allPaths?.FOURHTCONTENTFORM} exact component={FourthDesignContentForm} />
                <FifthLayout path={allPaths?.FIFHTHOME} exact component={FifthHome} />
                <FifthLayout path={allPaths?.FIFHTABOUT} exact component={FifthAbout} />
                <FifthLayout path={allPaths?.FIFHTSPECIALITIES} exact component={FifthSpecialities} />
                <FifthLayout path={allPaths?.FIFHTEXPERTIES} exact component={FifthExperties} />
                <FifthLayout path={allPaths?.FIFHTLATESTNEWS} exact component={FifthLatestNews} />
                <FifthLayout path={allPaths?.FIFHTCONTACT} exact component={FifthContact} />
                <FifthLayout path={allPaths?.FIFHTAPPOINTMENT} exact component={FifthAppointment} />
                <FifthLayout path={allPaths?.FIFHTWHOWEARE} exact component={WhoWeAre} />
                <FifthLayout path={allPaths?.FIFHTMISSIONANDVISION} exact component={MissionAndVision} />
                <FifthLayout path={allPaths?.FIFHTCOREVALUES} exact component={CoreValues} />
                <FifthLayout path={allPaths?.FIFHTTESTIMONIALS} exact component={Testimonials} />
                <FifthLayout path={allPaths?.FIFHTCAREERS} exact component={Careers} />
                <FifthLayout path={allPaths?.FIFHTOURTEAMS} exact component={FifthTeam} />
                <FifthLayout path={allPaths?.FIFHTOURTPHYSIOTHERAPYORTHOPEDIC} exact component={PhysiotherapyAndOrthopedic} />
                <FifthLayout path={allPaths?.FIFHTOURTREHABILITATION} exact component={Rehabilitation} />
                <FifthLayout path={allPaths?.FIFHTNEUROLOGYCENTRE} exact component={NeurologyCentre} />
                <FifthLayout path={allPaths?.FIFHTPEDIATRIC} exact component={PediatricRehabilitation} />
                <FifthLayout path={allPaths?.FIFHTCENTREEXPERTIES} exact component={BackCentreExpertise} />
                <FifthLayout path={allPaths?.FIFHTFOOTLAB} exact component={FootLab} />
                <FifthLayout path={allPaths?.FIFHTKNEECENTREOFEXPERTISE} exact component={KneeCentreOfExpertise} />
                <Route path={allPaths?.FIFHTCONTENTFORM} exact component={FifthDesignContentForm} />
                <Route path='/:page404' exact component={Page404} />
            </Switch >
        </Router >
    )
}

export {
    Page404, Routes
}
